import { render } from "./BonusCommissionDetail.vue?vue&type=template&id=3feaf654&scoped=true"
import script from "./BonusCommissionDetail.vue?vue&type=script&lang=js"
export * from "./BonusCommissionDetail.vue?vue&type=script&lang=js"

import "./BonusCommissionDetail.vue?vue&type=style&index=0&id=3feaf654&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3feaf654"

export default script